import React from "react";
import PropTypes from "prop-types";
import { switchDateFormat } from "./utils";
// import { DatePicker, DatePickerInput } from 'carbon-components-react';
import { DateFormat } from '../../../helpers/Constants';
import DateTimePicker from '../../DateTimePicker';
function DateWidget(props) {

    if (!props.id) {
        console.log("No id for", props);
        throw new Error(`no id for props ${JSON.stringify(props)}`);
    }
    const {
        value,
        readonly,
        disabled,
        autofocus,
        onBlur,
        onFocus,
        options,
        schema,
        formContext,
        registry,
        rawErrors,
        ...inputProps
    } = props;

    // If options.inputType is set use that as the input type
    if (options.inputType) {
        inputProps.type = options.inputType;
    } else if (!inputProps.type) {
        // If the schema is of type number or integer, set the input type to number
        if (schema.type === "number") {
            inputProps.type = "number";
            // Setting step to 'any' fixes a bug in Safari where decimals are not
            // allowed in number inputs
            inputProps.step = "any";
        } else if (schema.type === "integer") {
            inputProps.type = "number";
            // Since this is integer, you always want to step up or down in multiples
            // of 1
            inputProps.step = "1";
        } else {
            inputProps.type = "text";
        }
    }

    const _onChange = (name, value, alt) => {
        //value = data in formato BEDateFormat from './Constants';
        if (!value) return props.onChange(undefined);

        return props.onChange(value);
    };

    return (
        <DateTimePicker
            id={'date-picker-' + props.id}
            value={value}
            type="date"
            placeholder={DateFormat}
            className="open-up"
            name=""
            alt=""
            invalid={rawErrors && rawErrors.length > 0 ? true : false}
            onChange={_onChange}
            disabled={disabled}
        />
    );
}

if (process.env.NODE_ENV !== "production") {
    DateWidget.propTypes = {
        value: PropTypes.string,
    };
}

export default DateWidget;
